<template>
  <div class="feature-search">
    <div class="feature-search__toolbar">
      <b-form class="feature-search__form" @submit.prevent="searchFeature()">
        <b-form-input
            id="input"
            placeholder="جستجو ویژگی"
            v-model="searchedWord"
            class="feature-search__input"
        ></b-form-input>
      </b-form>
      <button type="button" class="feature-search__refresh" @click="refreshFeatures">
        <b-icon icon="arrow-clockwise"/>
      </button>
    </div>

    <div class="feature-search__list">
      <div
          class="feature-search__row"
          v-for="feature in dashboardFeature"
          :key="feature.id"
          v-if="handleFilterFunction(feature)">
        <button
            type="button"
            class="feature-search__item"
            @click="selectFeature(feature)">
          {{ feature.name }}
        </button>
        <button
            type="button"
            class="feature-search__edit"
            title="ویرایش ویژگی"
            @click.stop="editFeature(feature)">
          <b-icon icon="pencil"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "FeatureSearch",
  props: {
    filterFunction: {
      default: null
    }
  },
  data() {
    return {
      fields: [
        {key: "name", label: "نام ویژگی"},
        {key: "value", label: "مقدار ویژگی"},
        {key: "extraValue", label: ""},
        {key: "action", label: ""},
      ],
      searchedWord: ''
    };
  },
  computed: {
    ...mapGetters({
      product: 'Product/getProduct',
      dashboardFeature: 'Feature/getFilteredFeatures',
    })
  },
  methods: {
    searchFeature() {
      if (this.searchedWord != "") {
        const searchWord = {words: this.searchedWord};
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      }
    },
    async refreshFeatures() {
      await this.$store.dispatch("Feature/getFeatures");
    },
    selectFeature(feature) {
      this.$emit('selectedFeature', feature)
    },
    editFeature(feature) {
      this.$emit('editFeature', feature)
    },
    handleFilterFunction(featureItem) {
      if (this.filterFunction != null) {
        return this.filterFunction(featureItem)
      }
      return true
    }
  }
}
</script>

<style scoped>
.feature-search__toolbar {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.65rem;
}

.feature-search__form {
  flex: 1 1 auto;
  min-width: 0;
}

.feature-search__input {
  height: 40px;
  border-radius: 12px !important;
  border-color: rgba(30, 30, 30, 0.12) !important;
  background: #f7f7f8 !important;
}

.feature-search__refresh {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(30, 30, 30, 0.1);
  border-radius: 12px;
  background: #f7f7f8;
  color: #424242;
  cursor: pointer;
  flex: 0 0 auto;
}

.feature-search__refresh:hover {
  background: rgba(235, 61, 96, 0.12);
  color: var(--primary, #eb3d60);
}

.feature-search__list {
  height: 280px;
  overflow-y: auto;
  border-radius: 14px;
  border: 1px solid rgba(30, 30, 30, 0.08);
  background: #f5f5f6;
}

.feature-search__row {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid rgba(30, 30, 30, 0.06);
}

.feature-search__row:last-child {
  border-bottom: 0;
}

.feature-search__item {
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  padding: 0.7rem 0.85rem;
  border: 0;
  background: transparent;
  color: #2a2a2a;
  text-align: right;
  font-weight: 600;
  cursor: pointer;
}

.feature-search__item:hover {
  background: rgba(235, 61, 96, 0.1);
  color: #d12d50;
}

.feature-search__edit {
  width: 40px;
  flex: 0 0 auto;
  border: 0;
  border-right: 1px solid rgba(30, 30, 30, 0.06);
  background: transparent;
  color: #6b6b6b;
  cursor: pointer;
}

.feature-search__edit:hover {
  background: rgba(235, 61, 96, 0.12);
  color: #eb3d60;
}
</style>
